<template>
  <div>
    地图
  </div>
</template>

<script>
export default {
  name: "MapLayer"
}
</script>

<style scoped>

</style>